import Soon from './soon.js'
import AccessExport from './access.js'
import ServiceExport from './services.js'
import BillingExport from './billing.js'
import Login from './login.js'

module.exports = {
  Soon,
  AccessExport,
  ServiceExport,
  BillingExport,
  Login
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/core/index.js